import { Link, useNavigate } from "react-router-dom";
import styles from "./login.module.css";
import { StorageSetItem } from "../../../admin/components/StorageComp";
import Loader from "../../../admin/components/Loader";
import { useState } from "react";
import { Eye, EyeOff, Mail, Lock, Shield, Truck, Globe, ArrowLeft } from "react-feather";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { useWebsite } from "../../../context/WebsiteContext";

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { websiteData, currentDomain, loading: wLoading } = useWebsite();

  const themePrimaryColor = websiteData && websiteData?.home_config && websiteData?.home_config?.primaryColor ? websiteData?.home_config?.primaryColor : "#ef233c";
  const themeSecondaryColor = websiteData && websiteData?.home_config && websiteData?.home_config?.secondaryColor ? websiteData?.home_config?.secondaryColor : "#0a2a52";

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: "onChange",
  });

  async function onSubmit(data) {
    data = { ...data, utoken: websiteData ? websiteData?.utoken : '' };

    setLoading(true);
    setErrorMsg("");

    return axios.post(process.env.REACT_APP_API_URL + "v1/login", data).then((response) => {
      setLoading(false);

      if (response.data.status === "SUCCESS") {
        const resData = response.data.data;

        const essentialRes = { id: resData?.id, api_token: resData?.api_token, email: resData?.email, is_expired: resData?.is_expired, name: resData?.name, permissions: resData?.permissions, phone: resData?.phone, role_name: resData?.role_name, status: resData?.status, subscription: resData?.subscription, user_type: resData?.user_type, company: { id: resData?.company?.id, abb: resData?.company?.abb, company_name: resData?.company?.company_name, domain: resData?.company?.domain, pickup_country: resData?.company?.pickup_country, delivery_country: resData?.company?.delivery_country, urltoken: resData?.company?.urltoken } };

        StorageSetItem("bookAuthData", essentialRes, 24 * 60 * 60 * 1000);

        let companyDomain = resData?.company?.domain;

        console.log(resData);

        if (resData?.user_type === 5) {
          navigate("/customer/my-bookings");
        } else if (resData?.user_type === 3) {
          navigate("/driver/today-request-list");
        } else if (resData?.user_type === 1) {
          navigate("/dashboard");
        } else {
          if (currentDomain === process.env.REACT_APP_BASE_DOMAIN) {
            let redirectUrl = companyDomain;

            if (!/^https?:\/\//i.test(redirectUrl)) {
              redirectUrl = `${window.location.protocol}//${redirectUrl}`;
            }

            window.location.href = `${redirectUrl}/dashboard`;
            return;
          } else {
            navigate("/dashboard");
          }
        }
      }

      if (response.data.status === "ERROR") {
        setErrorMsg(response?.data?.message);
      }
    }).catch((error) => {
      if (error?.response?.data?.message) {
        setErrorMsg(error?.response?.data?.message);
      }
      setLoading(false);
    });
  }

  return (<>
    {wLoading && <Loader />}
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={styles.MainDiv} style={{ "--primary-color": themePrimaryColor, "--secondary-color": themeSecondaryColor }}>
      <div className={styles.LoginFormSec}>
        <div className={styles.LoginCard}>
          <Link to={"/"} className={styles.BackHomeBU}>
            <ArrowLeft size={18} />
            Back to home
          </Link>

          <div className={styles.LogoSection}>
            <img src={websiteData && websiteData?.home_config && websiteData?.home_config?.logoURL ? websiteData?.home_config?.logoURL : "/images/logo.png"} alt={websiteData && websiteData?.home_config && websiteData?.home_config?.companyName ? websiteData?.home_config?.companyName : 'EF LOGISTICS'} className={styles.LogoImage} />
            <h1 className={styles.LogoText}>{websiteData && websiteData?.home_config && websiteData?.home_config?.companyName ? websiteData?.home_config?.companyName : 'EF LOGISTICS'}</h1>
            <p className={styles.LogoSubText}>{websiteData && websiteData?.home_config && websiteData?.home_config?.heroTitle ? websiteData?.home_config?.heroTitle : 'Seamless Logistics from Pick-Up to Delivery'}</p>
          </div>

          <h2 className={styles.Title}>Welcome Back</h2>
          <p className={styles.SubTitle}>Login to access your account</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            {errorMsg && (<p className={styles.ErrorM} style={{ margin: '15px 0', fontWeight: 'bold' }}>{errorMsg}</p>)}

            <div className={styles.FormGroup}>
              <Controller
                control={control}
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  }
                })}
                render={({ field }) => (<TextField
                  {...field}
                  classes={{ root: styles.inputRoot }}
                  fullWidth
                  label="Email Address"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (<InputAdornment position="start">
                      <Mail size={18} />
                    </InputAdornment>)
                  }}
                />)}
              />
              {errors.email && (<span className={styles.ErrorM}>{errors.email.message}</span>)}
            </div>

            {/* PASSWORD */}
            <div className={styles.FormGroup}>
              <Controller
                control={control}
                {...register("password", {
                  required: "Password is required",
                })}
                render={({ field }) => (<TextField
                  {...field}
                  classes={{ root: styles.inputRoot }}
                  fullWidth
                  label="Password"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    startAdornment: (<InputAdornment position="start">
                      <Lock size={18} />
                    </InputAdornment>),
                    endAdornment: (<InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? (<EyeOff size={18} />) : (<Eye size={18} />)}
                      </IconButton>
                    </InputAdornment>),
                  }}
                />)}
              />

              {errors.password && (<span className={styles.ErrorM}>{errors.password.message}</span>)}
            </div>

            <div className={styles.ForgotPasswordRow}>
              <Link to={"/forgot-password"} className={styles.ForhotPassText}>Forgot Password?</Link>
            </div>

            <button type="submit" className={styles.LoginBU}>Login</button>

            {!(websiteData && websiteData?.home_config) && <>
              <div className={styles.Divider}>
                <span>or</span>
              </div>

              <p className={styles.FooterText}>Don&apos;t have an account?{" "}<Link to={"/sign-up"} className={styles.ForhotPassText}>Create Free Account</Link></p>
            </>}
          </form>
        </div>
      </div>

      <div className={styles.LoginBGSec}>
        <img src="/images/login-side-banner.png" alt="Logistics" className={styles.BGImage} />
        <div className={styles.Overlay}></div>

        <div className={styles.FeatureWrap}>
          <div className={styles.FeatureItem}>
            <Shield size={30} />
            <h4>Secure & Reliable</h4>
            <p>Advanced shipment protection and real-time tracking for complete peace of mind.</p>
          </div>

          <div className={styles.FeatureItem}>
            <Truck size={30} />
            <h4>Fast Transportation</h4>
            <p>Efficient road, air, and sea freight solutions with on-time delivery assurance.</p>
          </div>

          <div className={styles.FeatureItem}>
            <Globe size={30} />
            <h4>Worldwide Logistics</h4>
            <p>Connecting businesses globally with seamless supply chain and cargo management.</p>
          </div>
        </div>
      </div>
    </div>
  </>);
};

export default Login;